import React from "react";
import PlatformStatusBadge from "./PlatformStatusBadge";
import "./PlatformCard.css";

const ICON_GLYPHS = {
  web: "W",
  android: "A",
  ios: "iOS",
  "android-tv": "TV",
  "apple-tv": "ATV",
  "fire-tv": "Fire",
  roku: "Roku",
};

/**
 * A-009A — Presentational card for one platformAvailabilityPayload item.
 */
function PlatformCard({ platform }) {
  if (!platform) return null;

  const iconKey = platform.icon || platform.slug || "";
  const glyph = ICON_GLYPHS[iconKey] || (platform.name || "?").slice(0, 2);
  const available = platform.status_key === "available";
  const showCta = Boolean(platform.store_url && platform.cta_label);

  return (
    <article className="platform-card">
      <div className={`platform-card__icon platform-card__icon--${iconKey}`}>
        <span aria-hidden="true">{glyph}</span>
      </div>
      <div className="platform-card__body">
        <div className="platform-card__head">
          <h2 className="platform-card__name">{platform.name}</h2>
          <PlatformStatusBadge
            status={platform.status}
            badge={platform.badge}
            statusKey={platform.status_key}
          />
        </div>
        {platform.description ? (
          <p className="platform-card__desc">{platform.description}</p>
        ) : null}
        {platform.coming_soon_label ? (
          <p className="platform-card__soon">{platform.coming_soon_label}</p>
        ) : null}
        {showCta ? (
          <a
            className="btn btn-danger platform-card__cta"
            href={platform.store_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {platform.cta_label}
          </a>
        ) : (
          <p className="platform-card__status-only">
            {available ? "Available on this platform" : platform.status}
          </p>
        )}
      </div>
    </article>
  );
}

export default PlatformCard;
